import SiteContext from "../context/SiteContext";
import {useContext, useEffect, useState, useRef} from "react";
const IndustryChatDemoComposer = ({message, messageIndex}) => {

    const {currentMessageIndex, updateCurrentMessageSent, userTypingSpeed} = useContext(SiteContext);

    const [typedText, setTypedText] = useState("");


    const index = useRef(0)

    useEffect(() => {
        let typingTimer = null;
        let delayTimer = null
        if (messageIndex === currentMessageIndex) {
            if(index.current < message.text.length){
                typingTimer = setTimeout(() => {
                    setTypedText(typedText + message.text[index.current])
                    index.current++
                }, Number(userTypingSpeed));
            }else{
                delayTimer = setTimeout(() => {
                    updateCurrentMessageSent()
                }, 400);

            }
        }
        return () => {
            clearTimeout(typingTimer);
            clearTimeout(delayTimer);
        };
    }, [updateCurrentMessageSent, typedText, messageIndex, currentMessageIndex, userTypingSpeed, message.text]);





    return (
        <span className="chat-window-composer-text">
                {typedText}
        </span>

    );
};

export default IndustryChatDemoComposer;
